/**
 * Dearlove — Bundle & Save + personnalisation multi-items.
 *
 * Palier 1 : flux Dawn natif (product-form.js), les champs de l'item 1 sont
 * rattachés au form via l'attribut form= et postés en properties[...].
 * Paliers 2-3 : interception du submit (capture) et POST JSON /cart/add.js
 * avec items[] qty 1, chaque item portant ses propres properties, puis
 * re-render du cart drawer via le contrat Dawn (getSectionsToRender /
 * renderContents / PUB_SUB_EVENTS.cartUpdate).
 */

if (!customElements.get('dl-bundle')) {
  customElements.define(
    'dl-bundle',
    class DlBundle extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.form = document.getElementById(`product-form-${this.sectionId}`);
        this.productForm = this.form ? this.form.closest('product-form') : null;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.options = Array.from(this.querySelectorAll('.dl-bundle__option input'));
        this.persoSets = Array.from(this.querySelectorAll('[data-dl-perso-set]'));
        const variantsJson = this.querySelector('[data-dl-piece-variants]');
        this.pieceVariants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
        this.addEventListener('change', (evt) => {
          if (!evt.target.closest('[data-dl-piece-option]')) return;
          this.applyStoneCount();
          this.updatePieces();
        });

        this.options.forEach((input) => {
          input.addEventListener('change', () => {
            if (this.isBogo) return this.setQuantity(parseInt(input.value, 10));
            this.onTierChange();
          });
        });

        // La piece 2 (offerte) reprend les valeurs de la piece 1 par defaut.
        // Des que le client edite un champ de la piece 2, il garde la main dessus.
        const set1 = this.persoSetByIndex(1);
        const set2 = this.persoSetByIndex(2);
        if (set1 && set2) {
          set1.addEventListener('change', () => this.mirrorToSet2());
          set2.addEventListener('change', (evt) => {
            if (this.mirroring) return;
            const wrap = evt.target.closest('[data-dl-field]');
            if (wrap) wrap.dataset.dlDirty = 'true';
          });
        }

        // Maj immédiate du nombre de champs dès le changement du dropdown
        // (délégation : survit aux re-render Dawn, indépendant du fetch variante).
        if (!window.__dlStonesDelegated) {
          window.__dlStonesDelegated = true;
          document.addEventListener('change', (e) => {
            if (e.target && e.target.matches && e.target.matches('[data-dl-stones]')) {
              document.querySelectorAll('dl-bundle').forEach((b) => {
                if (b.applyStoneCount) b.applyStoneCount();
              });
            }
          });
        }

        if (this.form) {
          this.form.addEventListener('submit', (evt) => this.onSubmitCapture(evt), true);
        }

        // Dawn ne re-rend pas ce bloc au changement de variante : on rafraîchit
        // les prix des paliers depuis le HTML de section déjà re-fetché.
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          this.refreshTierPrices(event.data.html);
          this.applyStoneCount();
          if (this.qtyMode) {
            this.capQuantity();
            this.onTierChange();
            this.updatePieces();
          }
        });

        this.bindQuantity();
        if (this.isBogo) {
          const checked = this.options.find((o) => o.checked);
          if (checked) this.setQuantity(parseInt(checked.value, 10));
        }
        this.onTierChange();
        this.applyStoneCount();
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      refreshTierPrices(html) {
        const fresh = html && html.querySelector('dl-bundle');
        if (!fresh) return;
        const freshInputs = Array.from(fresh.querySelectorAll('.dl-bundle__option input'));
        this.options.forEach((input, i) => {
          const freshInput = freshInputs[i];
          if (!freshInput) return;
          input.dataset.totalLabel = freshInput.dataset.totalLabel || '';
          const prices = input.closest('.dl-bundle__option').querySelector('.dl-bundle__prices');
          const freshPrices = freshInput.closest('.dl-bundle__option').querySelector('.dl-bundle__prices');
          if (prices && freshPrices) prices.innerHTML = freshPrices.innerHTML;
        });
        this.onTierChange();
      }

      get qtyMode() {
        return this.dataset.qtyMode === 'true' && (this.isBogo || !this.options.length) && this.persoSets.length > 0;
      }

      // Offre « Buy 1, Get 1 Free » : les deux cartes pilotent la quantité (1 ou 2), chaque
      // pièce garde son encadré d'options, et les lignes portent _bundle=bogo pour la remise.
      get isBogo() {
        return this.dataset.bogo === 'true';
      }

      get qtyInput() {
        return document.getElementById(`Quantity-${this.sectionId}`);
      }

      get tier() {
        if (this.qtyMode) {
          const q = parseInt(this.qtyInput ? this.qtyInput.value : '1', 10) || 1;
          return Math.min(Math.max(q, 1), this.persoSets.length);
        }
        const checked = this.options.find((o) => o.checked);
        return checked ? parseInt(checked.value, 10) : 1;
      }

      // Mode quantité : un jeu de champs par pièce, la quantité plafonnée au nombre de jeux.
      // Délégation sur document : Dawn remplace le bloc quantité au changement de variante.
      bindQuantity() {
        if (!this.qtyMode || this.qtyBound) return;
        this.qtyBound = true;
        const onQty = (evt) => {
          const input = this.qtyInput;
          if (!input || evt.target !== input) return;
          this.capQuantity();
          this.onTierChange();
        };
        document.addEventListener('change', onQty);
        document.addEventListener('input', onQty);
        this.capQuantity();
      }

      setQuantity(q) {
        const input = this.qtyInput;
        if (!input) return;
        input.value = String(q);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      capQuantity() {
        const input = this.qtyInput;
        if (!input) return;
        const max = String(this.persoSets.length);
        input.max = max;
        input.dataset.max = max;
        if (parseInt(input.value, 10) > this.persoSets.length) input.value = max;
      }

      onTierChange() {
        const tier = this.tier;

        if (this.isBogo) {
          this.options.forEach((input) => {
            input.checked = input.value === (tier >= 2 ? '2' : '1');
          });
        }

        this.options.forEach((input) => {
          input.closest('.dl-bundle__option').classList.toggle('is-selected', input.checked);
        });

        this.persoSets.forEach((set) => {
          const idx = parseInt(set.dataset.dlPersoSet, 10);
          set.hidden = idx > tier;
          if (!this.qtyMode) return;
          // Le titre « Bracelet 1 » n'a de sens que s'il y a plusieurs pièces.
          const legend = set.querySelector('.dl-perso__set-title');
          if (legend) legend.hidden = tier < 2;
          // Sans personnalisation, la pièce 1 n'a rien à montrer tant qu'elle est seule.
          if (idx === 1 && !set.querySelector('[data-dl-field]')) set.hidden = tier < 2;
          // Une pièce qui apparaît part des options choisies en haut.
          if (idx >= 2 && !set.hidden && set.dataset.dlInit !== 'true') this.initPiece(set);
        });
        if (this.qtyMode) this.updatePieces();

        const checked = this.options.find((o) => o.checked);
        const submitBtn = this.productForm ? this.productForm.querySelector('[type="submit"] span') : null;
        if (submitBtn && checked && checked.dataset.totalLabel && !this.isBogo) {
          const base = window.variantStrings && window.variantStrings.addToCart ? window.variantStrings.addToCart : 'Add to cart';
          submitBtn.textContent = `${base} · ${checked.dataset.totalLabel}`;
        }

        if (tier >= 2 && !this.qtyMode) this.mirrorToSet2();
      }

      // Nombre de pierres = option de variante 'Number of Stones'. On affiche
      // les N premiers champs birthstone, on les rend requis, et on masque le reste.
      applyStoneCount() {
        const main =
          document.querySelector(`#variant-selects-${this.sectionId} [data-dl-stones]`) ||
          document.querySelector('[data-dl-stones]');
        const mainCount = main ? parseInt(main.value, 10) : 0;
        this.persoSets.forEach((set) => {
          // Pièces 2+ en mode quantité : leur propre option « Number of Stones ».
          let count = mainCount;
          const own = set.querySelector('[data-dl-piece-stones] input:checked');
          if (own) count = parseInt(own.value, 10);
          if (!count) return;
          set.querySelectorAll('[data-dl-field]').forEach((wrap) => {
            const idx = parseInt(wrap.dataset.fieldIndex, 10);
            if (!idx) return;
            const show = idx <= count;
            wrap.hidden = !show;
            wrap.dataset.required = show ? 'true' : 'false';
            const input = wrap.querySelector('select, input');
            if (input) {
              if (show) input.setAttribute('required', '');
              else input.removeAttribute('required');
            }
          });
        });

        this.applyConditionalFields();

        // Des champs viennent d'apparaitre : la piece 2 les reprend de la piece 1 (mode bundle).
        if (this.tier >= 2 && !this.qtyMode) this.mirrorToSet2();
      }

      // Champs « when » (ex. gravure payante) : visibles, requis et envoyés seulement si
      // l'option de variante nommée a la valeur attendue. Désactivé = absent du form natif.
      applyConditionalFields() {
        this.persoSets.forEach((set) => {
          set.querySelectorAll('[data-dl-field][data-when-option]').forEach((wrap) => {
            const show = this.selectedOptionValue(set, wrap.dataset.whenOption) === wrap.dataset.whenValue;
            wrap.hidden = !show;
            wrap.dataset.required = show ? 'true' : 'false';
            const input = wrap.querySelector('select, input');
            if (!input) return;
            input.disabled = !show;
            if (show) input.setAttribute('required', '');
            else input.removeAttribute('required');
          });
        });
      }

      selectedOptionValue(set, name) {
        const own = Array.from(set.querySelectorAll('[data-dl-piece-option]')).find((g) => g.dataset.optionName === name);
        if (own) {
          const checked = own.querySelector('input:checked');
          return checked ? checked.value : null;
        }
        const scope = document.getElementById(`variant-selects-${this.sectionId}`) || document;
        // Radios et <option> du picker Dawn portent data-option-name.
        const picked = Array.from(scope.querySelectorAll('input:checked[data-option-name], option:checked[data-option-name]'))
          .find((el) => el.dataset.optionName === name);
        return picked ? picked.value : null;
      }

      // --- Mode quantité : une variante par pièce ----------------------------
      mainVariant() {
        const idInput = this.form && this.form.querySelector('[name="id"]');
        const id = idInput ? parseInt(idInput.value, 10) : 0;
        return this.pieceVariants.find((v) => v.id === id) || null;
      }

      pieceVariant(set) {
        if (parseInt(set.dataset.dlPersoSet, 10) === 1) return this.mainVariant();
        const groups = Array.from(set.querySelectorAll('[data-dl-piece-option]'));
        if (!groups.length) return this.mainVariant();
        const opts = [];
        groups.forEach((g) => {
          const checked = g.querySelector('input:checked');
          opts[parseInt(g.dataset.dlPieceOption, 10)] = checked ? checked.value : null;
        });
        return this.pieceVariants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
      }

      initPiece(set) {
        const main = this.mainVariant();
        if (main) {
          set.querySelectorAll('[data-dl-piece-option]').forEach((g) => {
            const want = main.options[parseInt(g.dataset.dlPieceOption, 10)];
            g.querySelectorAll('input').forEach((input) => {
              input.checked = input.value === want;
            });
          });
        }
        set.dataset.dlInit = 'true';
        this.applyStoneCount();
      }

      updatePieces() {
        if (!this.qtyMode) return;
        const tier = this.tier;
        this.persoSets.forEach((set) => {
          if (set.hidden) return;
          const v = this.pieceVariant(set);
          const price = set.querySelector('[data-dl-piece-price]');
          if (price) price.textContent = v ? v.price : '';
          set.classList.toggle('is-unavailable', !v || !v.available);
          const summary = set.querySelector('[data-dl-piece-summary]');
          if (summary) {
            summary.hidden = tier < 2 || !v || v.options.length === 0 || v.options[0] === 'Default Title';
            if (v) summary.textContent = `${v.options.map((o) => { const lab = document.querySelector(`fieldset.dl-option-size input[value="${o}"] + label .dl-opt-local`); return lab ? lab.textContent : o; }).join(' / ')} (chosen above)`;
          }
        });
      }

      persoSetByIndex(index) {
        return this.persoSets.find((s) => parseInt(s.dataset.dlPersoSet, 10) === index);
      }

      // Recopie les valeurs de la piece 1 vers la piece 2, champ par champ,
      // en sautant ceux que le client a deja edites lui-meme.
      mirrorToSet2() {
        if (this.qtyMode) return;
        const set1 = this.persoSetByIndex(1);
        const set2 = this.persoSetByIndex(2);
        if (!set1 || !set2) return;

        this.mirroring = true;
        set1.querySelectorAll('[data-dl-field]').forEach((srcWrap) => {
          const dstWrap = set2.querySelector(`[data-dl-field][data-field-index="${srcWrap.dataset.fieldIndex}"]`);
          if (!dstWrap || dstWrap.hidden || dstWrap.dataset.dlDirty === 'true') return;
          const src = srcWrap.querySelector('input, select');
          const dst = dstWrap.querySelector('input, select');
          if (!src || !dst || dst.value === src.value) return;
          dst.value = src.value;
          dst.dispatchEvent(new Event('change', { bubbles: true }));
          dstWrap.classList.remove('has-error');
          const error = dstWrap.querySelector('.dl-perso__error');
          if (error) error.hidden = true;
        });
        this.mirroring = false;
      }

      collectProperties(setIndex) {
        const set = this.persoSets.find((s) => parseInt(s.dataset.dlPersoSet, 10) === setIndex);
        if (!set) return {};
        const props = {};
        set.querySelectorAll('[data-dl-field]').forEach((fieldWrap) => {
          if (fieldWrap.hidden) return;
          const input = fieldWrap.querySelector('input, select');
          if (input && input.value) props[fieldWrap.dataset.label] = input.value;
        });
        return props;
      }

      validateSets(tier) {
        let firstInvalid = null;
        for (let i = 1; i <= tier; i++) {
          const set = this.persoSets.find((s) => parseInt(s.dataset.dlPersoSet, 10) === i);
          if (!set) continue;
          set.querySelectorAll('[data-dl-field]').forEach((fieldWrap) => {
            const required = fieldWrap.dataset.required !== 'false';
            const input = fieldWrap.querySelector('input, select');
            const error = fieldWrap.querySelector('.dl-perso__error');
            // « min » (data-min) : nombre exact de caractères attendus, espaces non comptés
            const min = input ? parseInt(input.dataset.min || '0', 10) : 0;
            const invalid = required && input && (!input.value.trim() || (min > 0 && input.value.replace(/\s/g, '').length < min));
            fieldWrap.classList.toggle('has-error', invalid);
            if (error) error.hidden = !invalid;
            if (invalid && !firstInvalid) firstInvalid = input;
          });
        }
        if (firstInvalid) {
          firstInvalid.focus();
          return false;
        }
        return true;
      }

      onSubmitCapture(evt) {
        const tier = this.tier;

        if (tier <= 1) {
          if (this.persoSets.length && !this.validateSets(1)) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
          }
          return;
        }

        evt.preventDefault();
        evt.stopImmediatePropagation();

        if (this.persoSets.length && !this.validateSets(tier)) return;

        const variantId = parseInt(this.form.querySelector('[name="id"]').value, 10);
        const items = [];
        for (let i = 1; i <= tier; i++) {
          let id = variantId;
          if (this.qtyMode) {
            const set = this.persoSetByIndex(i);
            const v = set ? this.pieceVariant(set) : null;
            if (!v || !v.available) {
              if (set) {
                set.classList.add('is-unavailable');
                set.scrollIntoView({ block: 'center', behavior: 'smooth' });
              }
              return;
            }
            id = v.id;
          }
          const item = { id, quantity: 1 };
          const props = this.collectProperties(i);
          if (this.isBogo) props._bundle = 'bogo';
          if (Object.keys(props).length) item.properties = props;
          items.push(item);
        }

        const body = { items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        const submitButton = this.productForm ? this.productForm.querySelector('[type="submit"]') : null;
        const spinner = this.productForm ? this.productForm.querySelector('.loading__spinner') : null;
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
        }
        if (spinner) spinner.classList.remove('hidden');

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('[dl-bundle]', response.description || response.message);
              return;
            }
            if (!this.cart || !response.sections) {
              window.location = window.routes.cart_url;
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: variantId,
              cartData: response,
            });
            this.cart.renderContents(response);
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          })
          .catch((e) => console.error('[dl-bundle]', e))
          .finally(() => {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
